// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"m4-z","displaySixCardTiles":"n4-z"};